import { useForecastStore } from "stores/forecast";

export function useClearTypewells() {
  const setCheckedTypeWellKeys = useForecastStore((s) => s.setCheckedTypeWellKeys);
  const setExpandedTypeWellKeys = useForecastStore((s) => s.setExpandedTypeWellKeys);
  const setCheckedGlobalTypeWells = useForecastStore((s) => s.setCheckedGlobalTypeWells);
  const setCheckedTypeWells = useForecastStore((s) => s.setCheckedTypeWells);
  const setSelectedTypeWell = useForecastStore((s) => s.setSelectedTypeWell);

  function clearTypeWells() {
    setCheckedTypeWellKeys([]);
    setExpandedTypeWellKeys([]);
    setCheckedGlobalTypeWells([]);
    setCheckedTypeWells([]);
    setSelectedTypeWell(null);
  }

  return { update: clearTypeWells };
}
